
class GnavCategorySlider
  constructor: ->
    @init()

  init: ->
    self = @
    @width = 0
    @oneWidth = 125
    $gnav = $('.globalNav')
    @$gnavCategory = $gnav.find('.categories')
    @$gnavCategorySlider = $gnav.find('.categories.slide')

    @$gnavCategorySliderList = @$gnavCategorySlider.find('.category_list')
    @$gnavCategorySliderListItem = @$gnavCategorySliderList.find('li')

    @$gnavCategorySliderBtnPrev = @$gnavCategorySlider.find('.category_btn_prev')
    @$gnavCategorySliderBtnNext = @$gnavCategorySlider.find('.category_btn_next')

    $('.globalNav_item_wrapper').show()
    @setItemWidth()
    @setSlideItem()

    @$gnavCategorySliderBtnPrev.on 'click', ->
      self.prevSlide($(this))
    @$gnavCategorySliderBtnNext.on 'click', ->
      self.nextSlide($(this))

  setItemWidth: ->
    $('.category_list').each (i)->
      $box = $(this)
      maxWidth = 0;
      $box.find('li').each ->
        $item = $(this)
        if maxWidth < $item[0].clientWidth
          maxWidth = $item[0].clientWidth
        return
      $box.find('li').css({width: maxWidth});
      return
    # $('.globalNav_item_wrapper').hide()

  setSlideItem: ->
    width = 0
    self = @
    @slideObj = []
    @$gnavCategorySlider.each (i)->
      $slider = $(this)
      $sliderBox = $slider.find('.category_list')
      $sliderBoxItem = $sliderBox.find('li')
      $sliderBoxItem.each (j)->
        self.slideObj[i] = {width: $(this)[0].clientWidth, length: j+1}
        $(this).css({left: $(this)[0].clientWidth * j});
        return
      self.slideObj[i].allWidth = self.slideObj[i].width * self.slideObj[i].length
      $sliderBox.css { width: self.slideObj[i].allWidth }
      return

    #
    # @$gnavCategorySliderListItem.each (i)->
    #   width += 125
    #   $(this).css({left: 125 * i});
    #   return
    # @width = width
    # @$gnavCategorySliderList.css {width: width}
    $('.globalNav_item_wrapper').hide();

  getIndexNum: ($el)->
    return $('.categories.slide').index($el.parents('.categories.slide'))


  prevSlide: ($target)->
    i = @getIndexNum($target)
    @$gnavCategorySliderList.eq(i).css {transform: 'translateX(0)'}

    ###
    # @$gnavCategorySliderList.removeClass('next');
    # @$gnavCategorySliderList.addClass('prev');
    ###


  nextSlide: ($target)->
    i = @getIndexNum($target)
    tsWidth = @slideObj[i].allWidth - @$gnavCategorySlider.eq(i).width() + @$gnavCategorySliderBtnPrev.eq(i).width() + @$gnavCategorySliderBtnNext.eq(i).width()
    @$gnavCategorySliderList.eq(i).css {transform: 'translateX(-' + tsWidth + 'px)'}

    ###
    # @$gnavCategorySliderList.removeClass('prev');
    # @$gnavCategorySliderList.addClass('next');
    ###

module.exports = GnavCategorySlider



// WEBPACK FOOTER //
// ./src/scripts/modules/GnavCategorySlider.coffee